import React from 'react';
import { HelperLine, HelperText, ErrorMessage } from './mixins';
export var Helper = function Helper(_ref) {
  var name = _ref.name,
      fieldOptions = _ref.fieldOptions,
      errors = _ref.errors,
      _ref$noBottomMargin = _ref.noBottomMargin,
      noBottomMargin = _ref$noBottomMargin === void 0 ? false : _ref$noBottomMargin;
  if (!(fieldOptions && !!fieldOptions.helperText) && !(errors && errors[name]) && noBottomMargin) return null;
  return React.createElement(HelperLine, null, errors && errors[name] && React.createElement(ErrorMessage, null, errors[name].message), fieldOptions && fieldOptions.helperText && !(errors && errors[name]) && React.createElement(HelperText, null, fieldOptions.helperText));
};